import React from "react";
import NomenclatureTransactionsPage from "./NomenclatureTransactionsPage";
import useNomenclatureTransactions from "./useNomenclatureTransactions";

function NomenclatureTransactions(props) {
  return <NomenclatureTransactionsPage {...useNomenclatureTransactions(props)} />;
}

export default NomenclatureTransactions;
